import { HOME_ROUTE } from '../app/shared/constants/constants';

export const environment = {
  production: false,
  baseUrl: 'https://api.obesolution.dotitsrl.it/api/v1/',
  home: HOME_ROUTE,
  defaultLanguage: 'it',
  gtmId: 'GTM-XXXXXX',
  firebaseConfig: {
    apiKey: 'AIzaSyAr4Bc3rnqRBvGyPLMIOVK3zgTn23s5DmE',
    authDomain: 'test-9647d.firebaseapp.com',
    projectId: 'test-9647d',
    storageBucket: 'test-9647d.firebasestorage.app',
    messagingSenderId: '663501397748',
    appId: '1:663501397748:web:683015faa0d71215ed08a1',
    measurementId: 'G-8VXZL2KR5V',
    vapidKey:
      'BEKSxd5OsG4S3XXBe_MEI74VTU2Udo8eDhDTuEMR8MlUzDxHtiUOf4tilpMRgKBtsHYWILEszWulWZRlkwMskC0'
  },
  reverb: {
    appKey: '1f662b9e8d59995937bbfcca341042b4',
    wsHost: 'dev-wss-obesolution.dotitsrl.it',
    wsPort: 443,
    wssPort: 443,
    forceTLS: true,
    enabledTransports: ['ws', 'wss'],
    authEndpoint: 'https://api.obesolution.dotitsrl.it/broadcasting/auth'
  }
};
